import { defineCustomElements as ionicDefineCustomElements } from '@ionic/pwa-elements/loader';
import {IPlatformDependenciesManager} from "@kta20-core/interfaces/i-platform-dependencies-manager";

class UiPlatformDependenciesManager implements IPlatformDependenciesManager{
    async loadDependencies(params?: any,onCompleted?:()=>void):Promise<void> {
        params;

        // const ionicStyles = document.createElement('link');
        // ionicStyles.setAttribute('href', 'libs/@ionic/core/css/ionic.bundle.css');
        // ionicStyles.setAttribute('rel', 'stylesheet');
        // ionicStyles.setAttribute('type', 'text/css');

        const ionicScript = document.createElement('script');
        ionicScript.setAttribute('src', 'libs/@ionic/core/dist/ionic/ionic.js');
        ionicScript.setAttribute('type', 'text/javascript');

        //needed by Capacitor to fallback to web comps
        await ionicDefineCustomElements(window);

        //first includes and loads all styles then ionic js,
        //than invoked completed callback
        // ionicStyles.onload=()=>{
        //     document.head.appendChild(ionicScript);
        // };

        ionicScript.onload = async () => {
            onCompleted();
        };

        document.head.appendChild(ionicScript);
    }

}

export {UiPlatformDependenciesManager};